import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AuthGuard } from './auth/auth-guard.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class AppComponent {
  title = 'Mässtensvägen';
  theme: 'light' | 'dark' = this.getInitialTheme();

  constructor(public authGuard: AuthGuard) {
    this.applyTheme();
  }

  toggleTheme(): void {
    this.theme = this.theme === 'light' ? 'dark' : 'light';
    localStorage.setItem('wiup-theme', this.theme);
    this.applyTheme();
  }

  private getInitialTheme(): 'light' | 'dark' {
    const savedTheme = localStorage.getItem('wiup-theme');
    if (savedTheme === 'dark' || savedTheme === 'light') {
      return savedTheme;
    }

    return typeof window !== 'undefined' && typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  }

  private applyTheme(): void {
    document.documentElement.dataset['theme'] = this.theme;
  }
}
